<div class="relative bg-[var(--white)] p-8 mx-auto rounded-xl shadow-lg">
    <!-- Title and close button -->
    <div class="flex justify-between items-start mb-6">
      <h2 class="text-2xl text-[var(--black)] font-bold mr-8">Direcciones:</h2>
      <button 
        class="text-[var(--black)] hover:text-[var(--secondary)] transition-colors duration-200" 
        (click)="closeModal()"
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          class="h-6 w-6" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path 
            stroke-linecap="round" 
            stroke-linejoin="round" 
            stroke-width="2" 
            d="M6 18L18 6M6 6l12 12" 
          />
        </svg>
      </button>
    </div>




    <div class="flex flex-col gap-8 items-start">
        <button (click)="openMapWith('waze')" class="flex gap-4 border border-2 rounded-xl px-3 py-2"><fa-icon style="color: var(--black);" [icon]="faWaze" size="xl"></fa-icon>Waze</button>
        <button (click)="openMapWith('google')" class="flex gap-4 border border-2 rounded-xl px-3 py-2"><fa-icon style="color: var(--black);" [icon]="faGoogle" size="xl"></fa-icon>Google Maps</button>
        <button (click)="openMapWith('uber')" class="flex gap-4 border border-2 rounded-xl px-3 py-2"><fa-icon style="color: var(--black);" [icon]="faUber" size="xl"></fa-icon>Uber</button>
    </div>

  </div>